import React, { useCallback, useState } from 'react';
import { useField } from 'formik';
import { TextField, Typography } from '@mui/material';
import { showWarningSnackbar } from '../../../components/snackBar/snakbar';
import { LocationFetch } from '../../../library/LocationFetch';

const CustomTextField = React.memo(({ formik, name, onChange, disabled = false, label, required, states, ...props }) => {
  const [value, setValue] = useState(formik.values[name]);
  const handleChange = useCallback(
    async (event) => {
      if (name.includes('Pincode')) {
        if (value.length <= 6) {
          if (value.length === 6) {
            let res = await LocationFetch(value);

            if (name === 'dtPincode') {
              formik.setFieldValue('dtstates', `${res.State}District`);
              formik.setFieldValue('dtdistrict', `${res.District}`);
              formik.setFieldValue('dtPincode', value);
            } else if (name === 'dfPincode') {
              formik.setFieldValue('dfstates', `${res.State}District`);
              formik.setFieldValue('dfDistrict', `${res.District}`);
            }
          }
        } else {
          showWarningSnackbar('Please enter only 6 digits');
        }
      } else {
        formik.setFieldTouched([name], true);
        formik.setFieldValue(name, event.target.value);
        setValue(event.target.value);
      }
    },
    [value]
  );
  return (
    <>
      <TextField
        size="small"
        id={name}
        name={name}
        required={required}
        label={label}
        disabled={disabled}
        value={formik.values[name]?.includes('District') ? formik.values[name].replace(/district/gi, '') : formik.values[name] || value}
        onChange={handleChange}
        onBlur={() => formik.setFieldValue(name, value)}
        fullWidth
        sx={{
          '& .MuiInputLabel-root.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.2)', // or your theme-defined disabled color
          },
          '& .Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.2)', // keeps input text consistent
          },
        }}
        {...props}
        error={formik.touched[name] && formik.errors[name]}
      />
      {formik.touched[name] && formik.errors[name] ? (
        <Typography variant="body1" className="error" style={{ fontSize: '13px' }}>
          {formik.errors[name]}
        </Typography>
      ) : (
        <p style={{ padding: '12px' }}></p>
      )}
    </>
  );
});

export default CustomTextField;
